import gql from "graphql-tag";

export const CustomTenantInfoMenus = gql`
  query getBizTenantInfo($langCd: String!) {
    getBizTenantInfo(langCd: $langCd) {
      id
      code
      name
      tenant_type
      ask_location_type
      admin_tenant_flg
      is_client
      cc_status_visible
      survey_rating_enabled
      inquiry_reject_enabled
      name_dict
      description_dict
      lang_cd
      pictures
      logo
      background_image
      qr_invite_staff
      dch_hotel_id
      location_groups {
        id
        name
        position
        display_name
        is_default
        is_show_chat_history
        locations {
          id
          location_group_id
          name_dict
          qr
          default_name
          name
          hash_value
          pms_name
          cms_flag
        }
        color
        tenant_id
        main_menus {
          id
          location_group_id
          main_menu_id
          order_no
          sub_menus {
            id
            location_main_menu_id
            order_no
            sub_menu_id
          }
        }
      }
      main_menus {
        id
        code
        icon
        icon_code
        is_icon_with_letter
        name
        name_dict
        required_show_submenu
        tenant_id
      }
      sub_menus {
        admin_name
        admin_name_dict
        id
        menu_option
        menu_type
        name
        name_dict
        name_dict_status {
          is_all_lang_locked
          status
          updated_dict_lang_cds
        }
        staff_groups {
          id
          name
          order_no
          staff_group_id
          tenant_id
        }
        location_groups {
          color
        }
        sub_menu_type
        is_display
      }
      widget_on_off
    }
  }
`;
